import { ActiveStorageFile, ActiveStorageFileType } from "./ActiveStorageFile";
import { JSFile } from "./JSFile";
import { NullFile } from "./NullFile";

export type { ActiveStorageFileType };
export type UnifiedFileValue = File | ActiveStorageFileType | null;
export type UnifiedFile = {
  url: string;
  upload: () => Promise<
    | { error?: undefined; uploadedFile: UnifiedFile }
    | { error: string; uploadedFile?: undefined }
  >;
  signedId: string;
  size: number;
  isNull: boolean;
  value: UnifiedFileValue;
};

export const createUnifiedFile = (value: UnifiedFileValue): UnifiedFile => {
  if (value == null) {
    return new NullFile();
  } else if (value instanceof File) {
    return new JSFile(value);
  } else {
    return new ActiveStorageFile(value);
  }
};
